import { Pie } from "@ant-design/charts";

export default function ShedOccupationChart({
  occupied = 0,
  overCapacity = false,
  height = 150,
}) {
  const occ = Number(occupied) || 0;
  const available = Math.max(0, 100 - occ);

  const config = {
    data: [
      { status: "Terisi", percentage: occ },
      { status: "Tersedia", percentage: available },
    ],
    angleField: "percentage",
    colorField: "status",
    radius: 0.8,
    innerRadius: 0.5,
    scale: {
      color: {
        // merah saat over capacity, kuning saat normal
        range: [overCapacity ? "#cf1322" : "#f2b900", "#25a65a"],
      },
    },
    label: {
      text: (d) => `${d.percentage}% ${d.status}`,
      position: "outside",
      style: {
        fontSize: 10,
        fill: "#374151",
      },
    },
    legend: {
      position: "top",
    },
    height: height,
    autoFit: true,
  };

  return <Pie {...config} />;
}
